import React from 'react';
import {useSelector} from "react-redux";

const Footer = () => {

    const userType = useSelector((state)=>state.utilReducers?.userType)

  return (
    <footer className="w-full h-auto min-h-[6rem] mt-auto px-4 md:px-[4rem] py-4 md:py-[1rem] text-[#8A98AC] text-[1.2rem] md:text-[1.4rem] inter-font font-[600] flex flex-col md:flex-row justify-center">
  <div className="w-full md:w-[60%] flex justify-center md:justify-end items-center md:items-end mb-4 md:mb-0">
    <span className="hover:underline text-center md:text-right">© 2024 Paid promo - All Rights Reserved.</span>
  </div>
  <div className="w-full md:w-[40%] flex flex-wrap md:flex-row justify-center md:justify-end items-center md:items-end gap-4 md:space-x-[1.5rem]">
    {userType == 'BRAND' ? 
      <a target="_blank" className="hover:underline" href="https://terms.paidpromo.ai/brand_campaign_terms.html">Terms & Conditions</a>
      : userType === "AGENCY" ?
      <a target="_blank" className="hover:underline" href="https://terms.paidpromo.ai/agency_campaign_terms.html">Terms & Conditions</a>
      :
      <a target="_blank" className="hover:underline" href="https://terms.paidpromo.ai/influencer_campaign_terms.html">Terms & Conditions</a>
    }
    <a target="_blank" className="hover:underline" href="https://terms.paidpromo.ai/privacy.html">Privacy Policy</a>
    <a target="_blank" className="hover:underline" href="https://terms.paidpromo.ai/cookies.html">Cookies</a>
  </div>
</footer>
  );
};

export default Footer;
